import { FC } from 'react'
import Flex from '@/components/atoms/Grid/Flex'
import { Tiny2 } from '@/components/atoms/typography'
import styled, { useTheme } from 'styled-components'
import { useRouter } from 'next/router'
import Link from '@/components/atoms/link'
import MenuLogoutPart from '@/components/atoms/menuLogoutPart'
import { AccountIconDefault } from '../atoms/icons/AccountIconDefault'
import { IconButtonRedesign } from '@/components/molecules/iconButtons/iconButton'
import useTranslation from 'next-translate/useTranslation'

type ListLoginButtonRedesignProps = {
  hrefLink: string
  title: string
  isSigned: boolean
}

const ListLoginButtonRedesign: FC<ListLoginButtonRedesignProps> = ({
  hrefLink,
  title,
  isSigned
}) => {
  const { t } = useTranslation('common')
  const theme = useTheme()
  const router = useRouter()
  if (isSigned) {
    return (
      <Row>
        <ButtonWrapper
          onClick={(e) => {
            e.preventDefault()
            router.push(hrefLink)
          }}
        >
          <AccountIconDefault />
          <StyledTiny2 ml="9px">{title}</StyledTiny2>
        </ButtonWrapper>
        {isSigned && <MenuLogoutPart />}
      </Row>
    )
  } else {
    return (
      <Link href={hrefLink}>
        <IconButtonRedesign
          title={t('Toolbar.Buttons.loginRedesign')}
          IconElement={<AccountIconDefault color={theme.colors.background} />}
          titleColor={theme.colors.background}
        />
      </Link>
    )
  }
}

export default ListLoginButtonRedesign

const StyledTiny2 = styled(Tiny2)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.6;
`

const Row = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: stretch;
`

const ButtonWrapper = styled(Flex)`
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`
